import { useRef } from 'react'
import { AxiosError } from 'axios'
import { useInfiniteQuery } from '@tanstack/react-query'

import { Queries } from 'api/queries.enum'
import {
    GetPulseSurveysTemplatesParams,
    GetPulseSurveysTemplatesResponse,
} from 'api/actions/pulseSurveys/pulseSurveysActions.types'
import { preventRefetchQueryOptions } from 'utils/queryOptions'
import { getPulseSurveysTemplates } from 'api/actions/pulseSurveys/pulseSurveysActions'

export const useGetPulseSurveysTemplatesInfinite = (params?: GetPulseSurveysTemplatesParams) => {
    const queryInitialPage = useRef(params?.page || 1)

    const query = useInfiniteQuery<GetPulseSurveysTemplatesResponse, AxiosError>({
        queryKey: [Queries.getPulseSurveysTemplatesInfinite, params],
        queryFn: ({ pageParam = queryInitialPage.current }) => getPulseSurveysTemplates({ ...params, page: pageParam }),
        getNextPageParam: ({ page }) => page + 1,
        ...preventRefetchQueryOptions,
    })

    return query
}
